import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardComparisonComponent } from './dashboard-comparison/dashboard-comparison.component';
import { DeepDiveComponent } from './deep-dive/deep-dive.component';
import { EnginePricingInsightsComponent } from './engine-pricing-insights/engine-pricing-insights.component';
import { AuthGuard } from './shared/guards/auth.guard';
// Using custom override - bar chart with pink/red color
// import { BarChartComponent } from '@custom';
import { ChatComponent } from '@shared-lib/global-components/chat/chat.component';
import { NotificationsComponent } from '@shared-lib/global-components/notifications/notifications.component';
import { ReportsComponent } from '@shared-lib/global-components/reports/reports.component';
import { SystemAdminComponent } from '@shared-lib/global-components/system-admin/system-admin.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'palantir_charts',
    pathMatch: 'full',
  },
  // Price File Generator creation page.
  {
    path: 'oem',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: {
      configFile: 'price-file-generator/oem.json',
    },
  },


  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'dashboard-config.json' },
  },
  {
    path: 'all-chart-2',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-chart-2.json' },
  },
  {
    path: 'all-chart-3',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-chart-3.json' },
  },
  {
    path: 'test',
    component: DashboardComparisonComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'all-charts-dark-theme',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-charts-theme.json' },
  },

  {
    path: 'financial-metrics',
    component: DashboardComponent,
    data: { configFile: 'financial-metrics-poc.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'detailed_view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu_sales_overview.json' },
  },
  {
    path: 'europe-impact-report',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'europe-Impact-report.json' },
  },
  {
    path: 'dvm-charts_dark-theme',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'detailed_view-dark-theme.json' },
  },
  {
    path: 'palantir_charts',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'palantir.json' },
  },

  {
    path: 'quote-integration',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'quote-integration.json' },
  },

  {
    path: 'goms-customer',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'goms-customer.json' },
  },

  {
    path: 'dvm-charts',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'detailed_view-light-theme.json' },
  },


  // Price File Generator creation page.
  {
    path: 'Regional',
    redirectTo: 'regional',
    pathMatch: 'full',
  },
  {
    path: 'price-file-generator',
    redirectTo: 'regional',
    pathMatch: 'full',
  },
  {
    path: 'regional',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: {
      configFile: 'price-file-generator/price-file-simulation-new.json',
    },
  },

  {
    path: 'price-file-simulation/detail',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: {
      configFile: 'price-file-generator/price-file-simulation-detail.json',
    },
  },
  {
    path: 'price-file-simulation/deep-dive',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: {
      configFile: 'price-file-generator/price-file-simulation-deep-dive.json',
    },
  },
  {
    path: 'price-file-simulation',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: {
      configFile: 'price-file-generator/price-file-simulation.json',
    },
  },

  {
    path: 'reports/rer-engine-pricing-insights',
    component: EnginePricingInsightsComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'rer-engine-pricing-insights.json' },
  },

  {
    path: 'chat',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'chat-config.json' },
  },
  {
    path: 'notifications',
    component: NotificationsComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'notifications-config.json' },
  },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'reports-config.json' },
  },
  {
    path: 'reports/pricing-action-history',
    component: DeepDiveComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'administration',
    redirectTo: 'administration/model-management',
    pathMatch: 'full',
  },
  {
    path: 'administration/:section',
    component: SystemAdminComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'system-admin-config.json' },
  },
  {
    path: '**',
    redirectTo: 'palantir_charts',
  },
];
